module.exports = __webpack_public_path__ + "img/MG_GKLEAD.b19f4d13.webp";